<template>
  <div id="exam">
    <v-container grid-list-xl>
      <v-layout align-center justify-center row text-xs-center wrap>
        <v-flex sm6 xs12>
          <div class="resultContainer">
            <v-layout align-center fill-height justify-center row>
              <v-flex v-show="!startMode" xs12>
                <v-card color="transparent" elevation="0">
                  <v-card-text>
                    <div class="title mb-1">แบบทดสอบความเข้าใจ</div>
                    <div class="body-1 primary--text mb-2">
                      {{ `หัวข้อ : ${knowledges.topicName}` }}
                    </div>
                  </v-card-text>
                  <v-img
                    :aspect-ratio="16 / 9"
                    class="mx-5"
                    cover
                    :lazy-src="require('@/assets/NoPicture.png')"
                    :src="
                      knowledges.pictureCover
                        ? knowledges.pictureCover
                        : require('@/assets/NoPicture.png')
                    "
                  >
                    <template v-slot:placeholder>
                      <v-layout align-center fill-height justify-center ma-0>
                        <v-progress-circular
                          color="grey lighten-5"
                          indeterminate
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                  <v-card-text>
                    <div class="title">{{ knowledges.title }}</div>
                  </v-card-text>
                </v-card>
                <div class="title">จำนวนข้อ</div>
                <div class="display-2 my-2">{{ exams.length > 0 ? exams.length : '-' }}</div>
                <v-btn
                  class="subheading no-letter-spacing"
                  @click="startExam()"
                  color="#06E59F"
                  depressed
                  large
                  v-if="exams.length > 0"
                  >เริ่มทำแบบทดสอบ</v-btn
                >
              </v-flex>
              <v-flex v-show="startMode">
                <ExamChoiceBox :exams="exams" />
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import ExamChoiceBox from '../components/exams/ExamChoiceBox'
export default {
  name: 'exam',
  components: {
    ExamChoiceBox
  },
  data() {
    return {
      startMode: false,
      exams: [],
      answer: []
    }
  },
  computed: {
    knowledgeId() {
      return window.atob(this.$route.params.knowledgeId)
    },
    knowledges() {
      return this.$store.getters['Knowledge/getAll']
        .filter(item => item.idx == this.knowledgeId)
        .map(item => ({
          idx: item.idx,
          topicId: item.topicId,
          title: item.title,
          pictureCover: item.pictureCover,
          topicName: item.topicName
        }))[0]
    }
  },
  created() {
    this.$store.dispatch('Knowledge/fetch')
    this.getExam()
  },
  methods: {
    startExam() {
      this.startMode = !this.startMode
    },
    async getExam() {
      try {
        const response = await this.axios.get(`portal/exam/${this.knowledgeId}`)
        this.exams = response.data
        this.exams = _.shuffle(this.exams)
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-bottom {
  // position: relative;
  // bottom: 10px;
  // width: 100%;
}
.resultContainer {
  height: 100vh;
}
</style>
